import { useCallback, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "he_defws";

function readStored(): string {
  try {
    return localStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

/**
 * Default-workspace id (== PropelAuth org_id == workspace DB id).
 *
 * The workspace switcher, WorkspacesPage and useSelectWorkspace write
 * localStorage and then navigate. RootPage stays mounted across those
 * navigations, so the value is re-read *during render* whenever the location
 * changes — the redirect effect then sees the new workspace in the same commit
 * instead of redirecting back to the previous one.
 */
export function useDefaultWorkspaceId() {
  const location = useLocation();
  // Bumped by set/clear so writes made through this hook re-render immediately.
  const [version, setVersion] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const heDef = useMemo(() => readStored(), [location.key, version]);

  const setDefaultWorkspace = useCallback((id: string) => {
    localStorage.setItem(STORAGE_KEY, id);
    setVersion((v) => v + 1);
  }, []);

  const clearDefaultWorkspace = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setVersion((v) => v + 1);
  }, []);

  return { heDef, setDefaultWorkspace, clearDefaultWorkspace };
}
